var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 30,
    viewBox: "0 0 47 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 30,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2127 10.1115L21.0204 20.2648H18.3696L20.5622 10.1115H23.2127ZM34.3659 16.6675L35.7615 12.8546L36.5646 16.6675H34.3659ZM37.3236 20.2648H39.7756L37.6359 10.1115H35.3727C34.8641 10.1115 34.435 10.4046 34.2439 10.8564L30.2668 20.2648H33.0507L33.6034 18.7486H37.0044L37.3236 20.2648ZM30.405 16.9497C30.4164 14.2699 26.6647 14.1224 26.6906 12.9253C26.6984 12.5606 27.049 12.1737 27.8148 12.0744C28.1953 12.0252 29.2413 11.9876 30.429 12.5291L30.8941 10.376C30.2561 10.1466 29.4352 9.92578 28.4142 9.92578C25.7941 9.92578 23.9499 11.306 23.9344 13.2824C23.9178 14.7439 25.2509 15.5595 26.2554 16.0454C27.2881 16.5432 27.6351 16.862 27.6306 17.307C27.6238 17.9886 26.8067 18.2888 26.0445 18.3007C24.7115 18.3216 23.9379 17.9443 23.3213 17.6596L22.841 19.8843C23.4602 20.1661 24.6035 20.411 25.7896 20.4236C28.5741 20.4236 30.3959 19.0604 30.405 16.9497ZM19.4247 10.1115L15.1297 20.2648H12.3271L10.2136 12.1618C10.0852 11.6627 9.97363 11.4802 9.58344 11.2697C8.94676 10.9275 7.89426 10.6058 6.96826 10.4065L7.03151 10.1115H11.5422C12.1169 10.1115 12.6342 10.4907 12.7646 11.1466L13.881 17.0223L16.6395 10.1115H19.4247Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank2);
export default __webpack_public_path__ + "static/media/bank2.ac5cbb3719c3c0966b18058fe2dcef8d.svg";
export { ForwardRef as ReactComponent };